module.exports = __webpack_public_path__ + "img/1-Main-Menu.cf2d7772.png";